/* eslint-disable import/prefer-default-export,react/forbid-prop-types,react/display-name */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { LeftSide, RightSide } from './partials';

export const AccountDetailsContent = forwardRef(
  (
    {
      calendarFilter,
      refreshBalances,
      showStakingfeature,
      changesPercentage,
      displayCurrencyOnMobile,
      totalBalanceInFiat,
      totalChangeInFiat,
      fiatCurrencyCode,
      coin,
      availableBalance,
      totalBXXBalance,
      stakingAmount,
      renderFiatActionButtons,
      renderCryptoActionButtons,
      isStableCoin,
      isCryptoWallet,
      renderStakeNowBtn,
      showSearchInput,
      toggleSearchInput,
      renderSearchInput,
      setCalendarVisible,
      onScroll,
      isLoadingFirstTimeVisible,
      isTransactionsLoading,
      showEmptyList,
      renderFirstLoader,
      setSelectedTransaction,
      wallet,
      renderedList,
      renderEmptyList,
    },
    ref
  ) => (
    <>
      <div className="col-12 col-md-3">
        <LeftSide
          refreshBalances={refreshBalances}
          showStakingfeature={showStakingfeature}
          changesPercentage={changesPercentage}
          displayCurrencyOnMobile={displayCurrencyOnMobile}
          totalBalanceInFiat={totalBalanceInFiat}
          totalChangeInFiat={totalChangeInFiat}
          fiatCurrencyCode={fiatCurrencyCode}
          coin={coin}
          availableBalance={availableBalance}
          totalBXXBalance={totalBXXBalance}
          stakingAmount={stakingAmount}
          renderButtons={
            isCryptoWallet || isStableCoin ? renderCryptoActionButtons : renderFiatActionButtons
          }
          isLoading={isLoadingFirstTimeVisible}
          renderStakeNowBtn={renderStakeNowBtn}
        />
      </div>
      <div className="col-12 col-md-9 account-details-right-side-outer-container">
        <RightSide
          ref={ref}
          wallet={wallet}
          isTransactionsLoading={isTransactionsLoading}
          toggleSearchInput={toggleSearchInput}
          renderedList={renderedList}
          showEmptyList={showEmptyList}
          renderFirstLoader={renderFirstLoader}
          renderEmptyList={renderEmptyList}
          onScroll={onScroll}
          renderSearchInput={renderSearchInput}
          isLoadingFirstTimeVisible={isLoadingFirstTimeVisible}
          setSelectedTransaction={setSelectedTransaction}
          showSearchInput={showSearchInput}
          setCalendarVisible={setCalendarVisible}
          calendarFilter={calendarFilter}
        />
      </div>
    </>
  )
);

AccountDetailsContent.propTypes = {
  refreshBalances: PropTypes.func.isRequired,
  showStakingfeature: PropTypes.bool.isRequired,
  changesPercentage: PropTypes.number.isRequired,
  displayCurrencyOnMobile: PropTypes.bool.isRequired,
  totalBalanceInFiat: PropTypes.string.isRequired,
  totalChangeInFiat: PropTypes.string.isRequired,
  fiatCurrencyCode: PropTypes.string.isRequired,
  coin: PropTypes.string.isRequired,
  availableBalance: PropTypes.string.isRequired,
  totalBXXBalance: PropTypes.number.isRequired,
  stakingAmount: PropTypes.number.isRequired,
  renderFiatActionButtons: PropTypes.func.isRequired,
  renderCryptoActionButtons: PropTypes.func.isRequired,
  isStableCoin: PropTypes.bool.isRequired,
  isCryptoWallet: PropTypes.bool.isRequired,
  renderStakeNowBtn: PropTypes.func.isRequired,
  showSearchInput: PropTypes.bool.isRequired,
  toggleSearchInput: PropTypes.func.isRequired,
  renderSearchInput: PropTypes.func.isRequired,
  setCalendarVisible: PropTypes.func.isRequired,
  onScroll: PropTypes.func.isRequired,
  isLoadingFirstTimeVisible: PropTypes.bool.isRequired,
  isTransactionsLoading: PropTypes.bool.isRequired,
  showEmptyList: PropTypes.bool.isRequired,
  renderFirstLoader: PropTypes.func.isRequired,
  setSelectedTransaction: PropTypes.func.isRequired,
  renderEmptyList: PropTypes.func.isRequired,
  wallet: PropTypes.object.isRequired,
  renderedList: PropTypes.object.isRequired,
  calendarFilter: PropTypes.object.isRequired,
};
